/**
 * Moneris iFrame URL Builder
 */
import { MONERIS_BASE_URL, MONERIS_IFRAME_DEFAULTS } from '../constants/monerisConfig';

/**
 * Builds the Moneris Hosted Tokenization iframe URL.
 */
export function buildMonerisIframeUrl(profileId: string, overrides: Record<string, string> = {}): string {
  const url = new URL(MONERIS_BASE_URL);

  url.searchParams.set('id', profileId);

  const params = { ...MONERIS_IFRAME_DEFAULTS, ...overrides };

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, value);
    }
  }

  return url.toString();
}
